import { render, staticRenderFns } from "./GenialReport.vue?vue&type=template&id=528144fa&scoped=true"
import script from "./GenialReport.vue?vue&type=script&lang=js"
export * from "./GenialReport.vue?vue&type=script&lang=js"
import style0 from "./GenialReport.vue?vue&type=style&index=0&id=528144fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528144fa",
  null
  
)

export default component.exports